module.exports = __webpack_public_path__ + "static/img/wechat-videonumber.6dc8922.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wechat-videonumber.jpg
// module id = M+r4
// module chunks = 1